'use strict';

angular.module('shiftTraderApp')
  .service('TagCloudStore', ['$log', '$rootScope', 'Session', '$q', '$timeout', 'TagCloud',
    function ($log, $rootScope, Session, $q, $timeout, TagCloud) {
      var records = [];
      var cacheLastUpdated = null;
      var maxCacheAgeInSeconds = 60;
      var defers = [];
      var waitingOnRequest = false;

      var that = this;

      /**
       * Sorts the tags in descending order of popularity.
       * @param  {Array} recs Array of tags with usage number appended
       * @return {Array}      Sorted array from most popular to least
       */
      function sortTags(recs) {
        return (_.sortBy(recs, function(n) {
          return parseInt(n.split('-')[1]);
        })).reverse().map(function(t) {
          return t.split('-')[0];
        });
      }

      function updateCache(recs) {
        records = sortTags(recs);
        cacheLastUpdated = moment.utc();
      }

      function isCacheValid() {
        return !lodash.isNull(cacheLastUpdated) &&
          ((cacheLastUpdated + maxCacheAgeInSeconds) > moment.utc().unix());
      }

      this.flush = function() {
        records = [];
        cacheLastUpdated = null;
      };

      $rootScope.$on('flushCaches', function() {
        that.flush();
      });

      this.getMostPopular = function(amount) {
        return records.slice(0, amount);
      };

      this.getAll = function() {
        var deferred = $q.defer();

        if (isCacheValid()) {
          deferred.resolve(records);
        } else {
          defers.push(deferred);

          if (!waitingOnRequest) {
            TagCloud.getAll()
              .then(function(tags) {
                updateCache(tags);

                while (defers.length > 0) {
                  var d = defers.shift();
                  d.resolve(records);
                }

                waitingOnRequest = false;
              }, function(response) {
                while (defers.length > 0) {
                  var d = defers.shift();
                  d.reject(response);
                }

                waitingOnRequest = false;
              });
          }
        }
        return deferred.promise;
      };

  }]);
